'use client';

import classNames from 'classnames';

import { Icon } from '../icon/Icon';
import { ToastType } from './types';

export interface ToastProps {
	type: ToastType;
	text: string;
	buttonText: string;
	onClose: () => void;
}

export const Toast = ({ type, text, buttonText, onClose }: ToastProps) => {
	return (
		<div
			className={classNames('z-popup p-4 rounded-xl border flex items-center justify-between', {
				'border-takeda-dark-red-600 bg-takeda-dark-red-50 text-takeda-dark-red-600':
					type === ToastType.ERROR,
			})}
		>
			<div className="mr-4">
				{type === ToastType.ERROR && <Icon name="info" className="text-takeda-dark-red-600" />}
			</div>

			<div className="mr-16 flex-1">{text}</div>

			<button
				className={classNames('cursor-pointer', {
					'hover:text-takeda-dark-red-800': type === ToastType.ERROR,
				})}
				onClick={onClose}
			>
				{buttonText}
			</button>
		</div>
	);
};
